module.exports = __webpack_public_path__ + "static/media/buy.31be58ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_138/images/buy.png
// module id = 1301
// module chunks = 0